const isMongoId = str => str?.length === 24 && /^[A-F0-9]+$/i.test(str);

export default isMongoId;
